import './index.scss';
import ModalBase from '.';
import { copyToClipboard } from '../../helpers/utils';
import { ModalOTPProps } from '../../types';

function ModalOTP({ modalIsOpen, setIsOpen, otp, text }: ModalOTPProps) {
  function closeModal() {
    setIsOpen(false);
  }

  const ModalChildren = () => {
    return (
      <div className={`modal-base success flex--4`}>
        <span className="close" onClick={closeModal}>
          &times;
        </span>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h4>{text || 'OTP Generated'}</h4>
          <div
            style={{
              fontSize: '32px',
              fontWeight: 'bold',
              margin: '20px 0',
              letterSpacing: '5px',
              background: '#f4f4f4',
              padding: '10px',
              borderRadius: '8px',
              cursor: 'pointer',
              color: '#101828',
            }}
            onClick={() => copyToClipboard('OTP', otp)}
          >
            {otp}
          </div>
          <p style={{ fontSize: '14px', color: '#666' }}>Click code to copy</p>
          <button type="button" onClick={closeModal} style={{ marginTop: '20px' }}>
            Close
          </button>
        </div>
      </div>
    );
  };

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <ModalChildren />
    </ModalBase>
  );
}

export default ModalOTP;
